module.exports = __webpack_public_path__ + "static/img/14.0273858.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/14.png
// module id = /aAs
// module chunks = 0